var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCenter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 26.5,
    height: 26.5,
    rx: 1.25,
    stroke: "#6853C2",
    strokeOpacity: 0.8,
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1327 10.4531H4.72656C4.325 10.4531 4 10.1277 4 9.72656C4 9.325 4.325 9 4.72656 9H23.1327C23.5338 9 23.8592 9.325 23.8592 9.72656C23.8592 10.1277 23.5338 10.4531 23.1327 10.4531Z",
    fill: "#6853C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7733 14.8125H6.72656C6.32501 14.8125 6 14.487 6 14.0859C6 13.6848 6.32501 13.3593 6.72656 13.3593H20.7733C21.1745 13.3593 21.4999 13.6848 21.4999 14.0859C21.4999 14.487 21.1745 14.8125 20.7733 14.8125Z",
    fill: "#6853C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3849 19.1718H9.72656C9.325 19.1718 9 18.8464 9 18.4452C9 18.0441 9.325 17.7187 9.72656 17.7187H18.3849C18.7865 17.7187 19.1115 18.0441 19.1115 18.4452C19.1115 18.8464 18.7865 19.1718 18.3849 19.1718Z",
    fill: "#6853C2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenter);
export default __webpack_public_path__ + "static/media/center.9f5eb418c8a36c012e2f0a6e98b1d96c.svg";
export { ForwardRef as ReactComponent };